// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__31VkO","approved":"Status_approved__2NP26","rejected":"Status_rejected__2xIZq","expired":"Status_expired__2RVkZ","label":"Status_label__1c0Hh"};